module.exports = __webpack_public_path__ + "img/icon-test.676d5215.svg";